"use strict";

// Fonction utilitaire qui retourne une promesse qui se résout après un setTimeout avec une durée déterminée
// Ex: wait(duration en millisecondes).then(function() {
// 	do something...
// });
function wait(duration) {
	return new Promise(function(resolve) {
		setTimeout(resolve, duration);
	});
}

function debounce(callback, delay) {
	let timeout = null;

	return function() {
		clearTimeout(timeout);

		timeout = setTimeout(function() {
			callback();
		}, delay);
	};
}

/**
 *    ######## #### ##       ######## ######## ########   ######  
 *    ##        ##  ##          ##    ##       ##     ## ##    ## 
 *    ##        ##  ##          ##    ##       ##     ## ##       
 *    ######    ##  ##          ##    ######   ########   ######  
 *    ##        ##  ##          ##    ##       ##   ##         ## 
 *    ##        ##  ##          ##    ##       ##    ##  ##    ## 
 *    ##       #### ########    ##    ######## ##     ##  ######  
 */
function filterProducts() {
	const productsContainer = $('.all-products-ctn');
	const productsWrapper = productsContainer.find('.all-products').get(0);

	if (!productsWrapper) return;

	const selectedCategory = $('#filter-type').find('input:checked').val();
	const searchTerm = $('#search-input').val().toLowerCase().trim();
	console.log(searchTerm);
	

	productsContainer.addClass('--loading');
	productsWrapper.classList.add('--transitioning');

	wait(600).then(function() {
		animateProductsContainerHeight(function() {

			let visibleProductsCount = 0;

			$('.product-card').each(function() {
				const category = $(this).data('type').toString();
				const title = $(this).find('.product-info .title').text().toLowerCase();

				const categoryMatch =
					selectedCategory === 'all' ||
					category === selectedCategory;

				const searchMatch =
					searchTerm === '' ||
					title.includes(searchTerm);

				if (categoryMatch && searchMatch) {
					$(this).removeClass('--hidden');
					visibleProductsCount++;
				} else {
					$(this).addClass('--hidden');
				}
			});

			const productsGrid = $('.products-grid');

			if (visibleProductsCount === 0) {
				productsGrid.addClass('--hidden');
				$('.no-products').addClass('--is-visible');
			} else {
				productsGrid.removeClass('--hidden');
				$('.no-products').removeClass('--is-visible');
			}
		});
	});

	wait(1200).then(function() {
		productsContainer.removeClass('--loading');
		productsWrapper.classList.remove('--transitioning');
	});
}

const debouncedFilterProducts = debounce(function() {
	filterProducts();
}, 300);

// Animation de la hauteur du conteneur des produits
function animateProductsContainerHeight(callback) {
	const container = document.querySelector('.all-products-ctn');
	const content = document.querySelector('.all-products');

	if (!container || !content) {
		if (typeof callback === 'function') callback();
		return;
	}

	// Nettoie une transition précédente
	container.style.transition = 'none';
	container.style.height = container.offsetHeight + 'px';

	// Force repaint
	container.offsetHeight;

	// Remet la transition
	container.style.transition = 'height 0.4s ease';

	if (typeof callback === 'function') callback();

	const endHeight = content.scrollHeight;

	requestAnimationFrame(function() {
		container.style.height = endHeight + 'px';
	});

	const onTransitionEnd = function(event) {
		if (event.propertyName !== 'height') return;

		container.style.height = 'auto';
		container.removeEventListener('transitionend', onTransitionEnd);
	};

	container.addEventListener('transitionend', onTransitionEnd);
}

/**
 *                                                                                                                            
 *     ###### # #      ##### ###### #####     #####  #   #     ####    ##   ##### ######  ####   ####  #####  # ######  ####  
 *     #      # #        #   #      #    #    #    #  # #     #    #  #  #    #   #      #    # #    # #    # # #      #      
 *     #####  # #        #   #####  #    #    #####    #      #      #    #   #   #####  #      #    # #    # # #####   ####  
 *     #      # #        #   #      #####     #    #   #      #      ######   #   #      #  ### #    # #####  # #           # 
 *     #      # #        #   #      #   #     #    #   #      #    # #    #   #   #      #    # #    # #   #  # #      #    # 
 *     #      # ######   #   ###### #    #    #####    #       ####  #    #   #   ######  ####   ####  #    # # ######  ####  
 *                                                                                                                            
 */
$('#filter-type').on('change', debouncedFilterProducts);
$('#search-input').on('keyup', debouncedFilterProducts);
